import { render } from "./CommentModule.vue?vue&type=template&id=86a74dcc&scoped=true"
import script from "./CommentModule.vue?vue&type=script&lang=js"
export * from "./CommentModule.vue?vue&type=script&lang=js"

import "./CommentModule.vue?vue&type=style&index=0&id=86a74dcc&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a74dcc"]])